<template>
  <div id="app" :style="{ visibility: visibility }">
    <!--<transition name="fade">-->
    <component :is="layout" />
    <!--</transition>-->
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="blob-mask">
      <defs>
        <filter id="blob">
          <feGaussianBlur in="SourceGraphic" stdDeviation="2" result="blur" />
          <feColorMatrix
            in="blur"
            mode="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 7 -2"
            result="blob"
          />
          <feBlend in="SourceGraphic" in2="blob" />
        </filter>
      </defs>
    </svg>

    <affiliate-referer></affiliate-referer>
  </div>
</template>

<script>
import * as Layouts from 'views/layouts'
import AffiliateReferer from 'views/components/affiliate-referer'
import { EventBus } from '@/util/event-bus.js'

const EXCLUDE_PATHS = ['/login-social', '/ko/error/login'] // 인증 로직 거치지 않거나 마케팅 로그 전송 제외할 경로들

export default {
  name: 'app',

  metaInfo() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk}` : this.$t('slogan') //${this.$t('brand')}
      },
      script: [
        {
          innerHTML:
            '!function(e,n,t,o,c,s,a){e.fbq||(c=e.fbq=function(){c.callMethod?c.callMethod.apply(c,arguments):c.queue.push(arguments)},e._fbq||(e._fbq=c),c.push=c,c.loaded=!0,c.version="2.0",c.queue=[],(s=n.createElement(t)).async=!0,s.src="https://connect.facebook.net/en_US/fbevents.js",(a=n.getElementsByTagName(t)[0]).parentNode.insertBefore(s,a))}(window,document,"script"),fbq("init","2227998534192753");',
        },
        {
          innerHTML:
            '{\n' +
            '    "@context" : "https://schema.org",\n' +
            '    "@type" : "Organization",\n' +
            '    "name" : "하나투어 :: 1등 여행사",\n' +
            '    "url" : "https://fnd.hanatour.com/",\n' +
            '    "logo" : "",\n' +
            '    "sameAs" : [\n' +
            '      "https://mfnd.hanatour.com/"\n' +
            '    ]\n' +
            '    }',
          type: 'application/ld+json',
        },
        {
          src: `//cdn.megadata.co.kr/js/en_script/3.5/enliple_min3.5.js`,
          defer: `defer`,
        },
        {
          src: '//code.jquery.com/jquery-3.3.1.min.js',
          crossorigin: 'anonymous',
        },
        { innerHTML: `var wt_serv_env = ${process.env.APP_ENV === 'PROD' ? '"prd"' : null}; ` },
      ],
      __dangerouslyDisableSanitizers: ['script'],
      meta: [
        // 마이페이지의 중첩 경로와 별도 바우처 경로에 검색 제외 태그를 적용한다.
        ...(this.$route.matched.some((route) => route.meta.noindex)
          ? [{ vmid: 'robots', name: 'robots', content: 'noindex, nofollow' }]
          : []),
        { charset: 'utf-8' },
        //Webmaster SEO
        // {name: 'naver-site-verification', content: '0a2d7ecf8f36fead7569474385d847d1e05ec66b'},
        // {name: 'google-site-verification', content: 'qDn-CKrIVXVL3e0p9FG9hWFaW29o2890PISbXqacTtc'},
        // {name: 'msvalidate.01', content: 'EE71503700A76CB95A27DFCE8033BAE4'},
        // {name: 'yandex-verification', content: '83626cce46054d82'},
        { name: 'viewport', content: 'width=1280, minimal-ui' },
        // { name: 'theme-color', content: '#f60' },
        { vmid: 'compatible', 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { vmid: 'keywords', name: 'keywords', content: '' },
        { vmid: 'description', name: 'description', content: '하나투어 :: 1등 여행사' },
        // {vmid: 'og:title', property: 'og:title', content: '하나투어 :: 1등 여행사'},
        // {vmid: 'og:description', property: 'og:description', content: '하나투어 :: 1등 여행사'},
        // {vmid: 'og:image', property: 'og:image', content: 'https://www.mohaji.com/public/mohaji_og_img.png'},
        // {vmid: 'og:url', property: 'og:url', content: 'https://www.mohaji.com'},
        // {vmid: 'twitter:card', name: 'twitter:card', content: 'summary'},
        // {vmid: 'twitter:title', name: 'twitter:title', content: '하나투어 :: 1등 여행사'},
        // {vmid: 'twitter:description', name: 'twitter:description', content: '하나투어 :: 1등 여행사'},
        // {vmid: 'twitter:image', name: 'twitter:image', content: 'https://www.mohaji.com/public/mohaji_og_img.png'},
        // {vmid: 'twitter:url', name: 'twitter:url', content: 'https://www.mohaji.com'},
      ],
      link: [
        { rel: 'icon', href: '/public/favicon-16x16.png', sizes: '16x16' },
        { rel: 'icon', href: '/public/favicon-32x32.png', sizes: '32x32' },
        { rel: 'icon', href: '/public/favicon-96x96.png', sizes: '96x96' },
        { rel: 'shortcut icon', href: '/public/favicon.ico' },
        { rel: 'icon', href: '/public/favicon.ico' },
        { rel: 'preload', href: '/public/image-error.png', as: 'image' },
      ],
    }
  },

  props: ['langCode'],

  components: {
    ...Layouts,
    AffiliateReferer,
  },

  data() {
    return {
      visibility: 'hidden',
    }
  },

  computed: {
    layout() {
      return `${this.$route.meta.layout || 'default'}-layout`
    },
  },

  mounted() {
    this.visibility = 'visible'
    this.$bar.finish()
    this.$nextTick(() => {
      setTimeout(this.scrollTrigger, 100)
    })

    // 현재 라우트정보와 동일한 링크를 갖는 router-link 클릭 시, hook을 타지 않는 vue-router 이슈로 인해,
    // 우회코드 작성
    document.querySelector('body').addEventListener(
      'click',
      (event) => {
        const clickedEl = findParent('a', event.target)
        if (clickedEl && clickedEl.classList.contains('router-link-exact-active')) {
          // this.$router.replace({path:this.$route.path, query:{ROUTER_REPLACE:undefined} });
        }
      },
      false
    )

    function findParent(tagname, el) {
      while (el) {
        if ((el.nodeName || el.tagName).toLowerCase() === tagname.toLowerCase()) {
          return el
        }
        el = el.parentNode
      }
      return null
    }

    document.addEventListener(
      'keydown',
      (event) => {
        event = event || window.event
        const { keyCode, which } = event
        const keycode = keyCode || which
        EventBus.$emit('keydown', event)
      },
      false
    )

    this.sendCRM()
  },
  watch: {
    '$route.path': 'sendCRM',
  },
  methods: {
    sendCRM() {
      if (EXCLUDE_PATHS.includes(this.$route.path)) {
        return
      }

      try {
        this.$appBoy.sendAmplitudeEvent('load_pages')
        this.$hanaLog.send()
      } catch (e) {
        console.log('setCrm load_pages & hanalog e:::', e)
      }
    },
  },
}
</script>

<style lang="scss" src="./assets/scss/common.scss" />
